<template>
  <table class="table table-striped table-bordered">
    <thead>
      <tr>
        <th>Produkt</th>
        <th class="text-center">Menge</th>
        <th class="text-center">&Oslash; VK (n) / Stk.</th>
        <th class="text-center">EK (n) / Stk.</th>
        <th class="text-center">&sum; VK (n) </th>
        <th class="text-center">&sum; EK (n) </th>
        <th class="text-center"><strong>DB</strong></th>
        <th class="text-center" v-if="viewType === 'product'"></th>
      </tr>
    </thead>
    <transition name="el-fade-in-linear">
      <tbody v-if="! loading">
        <tr is="RevenueRow" v-for="stockRotation in stockRotations" :key="stockRotation.id"
          :stock-rotation="stockRotation"
          :get-db="getDb" :get-umsatz="getUmsatz" :get-preis="getPreis"
          :view-type="viewType"
          @openVariations="$emit('openVariations', $event)"
        />
      </tbody>
    </transition>
    <tfoot>
      <tr>
        <td colspan="4">
          <strong>Summe:</strong>
        </td>
        <td class="text-right">
          <strong>{{ totalUmsatz | priceFromCentZeroEuro }}</strong>
        </td>
        <td class="text-right">
          <strong>{{ totalPrice | priceFromCentZeroEuro }}</strong>
        </td>
        <td class="text-right">
          <strong>{{ totalDb | priceFromCentZeroEuro }}</strong>
        </td>
      </tr>
    </tfoot>
  </table>
</template>

<script>
import RevenueRow from './revenue-row'

export default {
  props: ['stockRotations', 'loading', 'viewType'],
  components: { RevenueRow },
  data () {
    return {

    }
  },
  methods: {
    getDb (stockRotation) {
      const einkaufsPreis = stockRotation.cheapestSupplier || stockRotation.product_instance.product.standard_price
      const umsatz = this.getUmsatz(stockRotation)
      if (umsatz && einkaufsPreis) {
        return umsatz - (einkaufsPreis * stockRotation.quantity_sold)
      }
      return 0
    },
    getUmsatz (stockRotation) {
      return +stockRotation.sum_price_sold
    },
    getPreis (stockRotation) {
      const price = stockRotation.cheapestSupplier || stockRotation.product_instance.product.standard_price
      return price * stockRotation.quantity_sold
    }
  },
  computed: {
    totalDb () {
      return this.stockRotations.reduce((total, stockRotation) => {
        const db = this.getDb(stockRotation)
        return total + db
      }, 0)
    },
    totalUmsatz () {
      return this.stockRotations.reduce((total, stockRotation) => {
        const umsatz = this.getUmsatz(stockRotation)
        return total + umsatz
      }, 0)
    },
    totalPrice () {
      return this.stockRotations.reduce((total, stockRotation) => {
        const preis = this.getPreis(stockRotation)
        return total + preis
      }, 0)
    }
  }
}
</script>

<style>
</style>
